// extracted by mini-css-extract-plugin
export default {"summaryRow":"HYK5WPy_ONtrV4Vun_oT","mealDetails":"_eVOuiuBi_6Ytw1o5xKp"};